/**
 * requestIdleCallback wrapper with Safari fallback.
 * Returns a cancel function.
 */
export function requestIdle(fn, options = {}) {
  const timeout = typeof options.timeout === 'number' ? options.timeout : 1500;

  if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
    const id = window.requestIdleCallback(fn, { timeout });
    return () => window.cancelIdleCallback?.(id);
  }

  const id = window.setTimeout(() => {
    fn({
      didTimeout: true,
      timeRemaining: () => 0,
    });
  }, 0);

  return () => window.clearTimeout(id);
}

